<div id="trainingRequirements">
<p-dialog
  header="Training Requirement History"
  [(visible)]="isTrainingRequirementHistoryModelOpen"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '90vw','margin-left': '1em' }"
  [closeOnEscape]="false"
>
  <app-panel-list [panelList]="trainingOccurrencesListInput"
  [noResultFound] = "noData">
    <ng-template #templateRef let-data="dataVar">
      <div panel-content class="grid">
        <div class="col-fixed text-left" style="width: 22%">
          <div class="font-semibold mb-1">Training Item</div>
          <div *ngIf="data?.type === 'Document'">
            <a
              class="overflow-ellipse-link"
              style="cursor: pointer"
              (click)="openDocument(data?.trainingItemId, data?.documentVersionNumber)"
            >
              <app-read-only
                readonlyText="{{ data?.trainingItemId }} {{ data?.title }} (v{{
                  data?.documentVersionNumber
                }})"
                toolTipMessage="{{ data?.trainingItemId }} {{ data?.title }} (v{{
                  data?.documentVersionNumber
                }})"
              >
              </app-read-only>
            </a>
          </div>
          <div *ngIf="data?.type === 'Course'" class="flex items-center gap-2">
            <a
              class="overflow-ellipse-link"
              style="cursor: pointer"
              (click)="openCourse(data?.trainingItemId)"
            >
              <app-read-only
                [readonlyText]="data?.trainingItemId + ' ' + data?.title"
                [toolTipMessage]="data?.trainingItemId + ' ' + data?.title"
              >
              </app-read-only>
            </a>
              <em *ngIf="data?.sessionIds?.length"  class="pi pi-calendar mt-1 blue-color cursor-pointer" (click)="openSessionDetailsModal(data?.sessionIds)"></em>
          </div>
        </div>
        <div class="col-fixed" style="width: 8%">
          <div class="font-semibold mb-1">Training</div>
          <div class="content-wrap">
            <em
              class="pi pi-circle-fill"
              [ngClass]="getStatusClass(data?.trainingStatus)"
            ></em>
            {{ data?.trainingStatus }}
          </div>
        </div>
        <div class="col-fixed text-left" style="width: 11%">
          <div class="font-semibold mb-1">Assignment Date</div>
          <div class="content-wrap">
            {{ data?.assignmentDate | date : 'dd-MMM-yyyy' }}
          </div>
        </div>
        <div class="col-fixed text-left" style="width: 8%">
          <div class="font-semibold mb-1">Due Date</div>
          <div class="content-wrap">
            {{ data?.dueDate | date : 'dd-MMM-yyyy' }}
          </div>
        </div>
        <div class="col-fixed text-left" style="width: 9%">
          <div class="font-semibold mb-1">Complete Date</div>
          <div class="content-wrap">
            {{ data?.completeDate | date : 'dd-MMM-yyyy' }}
            <i *ngIf="data?.completeDate!== null && data?.completeDate!== 'NaN' && data?.completeDate!== 'undefined' && !data?.isAuditAvailableForTrainingOccurrence" 
            class="fa-solid fa-file-signature ml-2 blue-color cursor-pointer" pTooltip="eSignature"  (click)="openESignature(data)"></i>
            <i *ngIf="data?.isAuditAvailableForTrainingOccurrence " 
            class="fas fa-chart-column fa-lg ml-2 blue-color cursor-pointer" pTooltip="Quiz Answer Audit"  (click)="openQuizAudit(data?.trainingItemId, data?.order, data?.type, data?.documentVersionNumber)"></i>
          </div>
        </div>
        <div class="col-fixed text-left" style="width: 10%">
          <div class="font-semibold mb-1">Expiration Date</div>
          <div class="content-wrap" *ngIf="data?.type === 'Document'">
            {{ data?.expirationDate?.documentExpirationDate }}
          </div>
          <div class="content-wrap" *ngIf="data?.type === 'Course'">
            {{ data?.expirationDate?.courseExpirationDate | date : 'dd-MMM-yyyy' }}
          </div>
        </div>
        <div class="col-fixed text-left" style="width: 12%">
          <div class="font-semibold mb-1">Cancellation Date</div>
          <div class="content-wrap">
            {{ data?.cancellationDate | date : 'dd-MMM-yyyy' }}
          </div>
        </div>
        <div class="col-fixed text-left" style="width: 10%">
          <div class="font-semibold mb-1">Removal Date</div>
          <div class="content-wrap">
            {{ data?.removalDate | date : 'dd-MMM-yyyy' }}
          </div>
        </div>
        <div class="col-fixed text-left" style="width: 10%">
  <div class="font-semibold mb-1">Revocation Date</div>
  <div class="content-wrap" style="display: flex; align-items: center; gap: 4px;">
    <span>{{ data?.revocationDate | date : 'dd-MMM-yyyy' }}</span>
    <i *ngIf="data?.revocationDate" class="fa fa-comment ml-2 blue-color cursor-pointer" [pTooltip]="data?.revocationReason || ''">
    </i>
  </div>
</div>


      </div>

    </ng-template>

  </app-panel-list>
</p-dialog>

<p-dialog *ngIf="isESignatureModalOpen"
  header="eSignature"
  [(visible)]="isESignatureModalOpen"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '35vw','margin-left': '1em' }"
>
<div panel-content class="grid">
  <div class="col-fixed text-left content-padding" style="width: 100%">
<div class="font-semibold mb-1">User</div>
  <div class="content-wrap">
    {{eSignatureInfo.esignature}}
  </div>
  <div></div><br>
<div class="font-semibold mb-1">Date & Time  </div>
  <div class="content-wrap">
    {{ eSignatureInfo.esignatureDateTime | date : "dd-MMM-yyyy HH:mm": "UTC"}} {{timeZoneFormat}}
</div>
<div></div><br>
<div class="font-semibold mb-1">Meaning</div>
  <div class="content-wrap">
    {{eSignatureInfo.esignatureMeaning}}
  </div>
</div>
</div>
</p-dialog>
</div>
<div *ngIf="isQuizAnswerAuditModalOpen">
  <app-training-occurrence-quiz-audit [trainingRequirementType]="trainingRequirementType" [documentVersionNumber]="documentVersionNumber"
  [trainingQuizAnswerDetails]="trainingQuizAnswerDetails" [trainingItemNumber]="trainingItemId"></app-training-occurrence-quiz-audit>
</div>
<app-session-panel-list *ngIf="isSessionDetailsModalOpen"
 [sessionIds]="sessionIdsLinkedWithCourseTrainingOccurrence"
 (showSessionDetailsModal)="closeSessionDetailsModal($event)">
</app-session-panel-list>
